"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progressbar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * Border radius for the container and for the progress bar
 */
const BORDER_RADIUS = '4px';
/**
 * Styled native progress element
 *
 * @param max {number} - This attribute describes how much work the task indicated by the `progress` element requires.
 * The `max` attribute, if present, must have a value greater than `0` and be a valid floating point number.
 * The default value is `1`.
 * @param value {number} - This attribute specifies how much of the task that has been completed.
 * It must be a valid floating point number between `0` and `max`, or between `0` and `1` if `max` is omitted.
 * If there is no `value` attribute, the progress bar is indeterminate;
 * this indicates that an activity is ongoing with no indication of how long it is expected to take.
 */
exports.Progressbar = styled_components_1.default.progress `
  /* Resets */
  appearance: none;
  border: none;

  width: 100%;
  height: 8px;

  overflow: hidden;

  /* Legacy Edge styles */
  color: ${({ theme }) => theme.designSystem.darkerAccent};
  background-color: ${({ theme }) => theme.designSystem.highlightedBackground};
  border-radius: ${BORDER_RADIUS};

  &::-ms-fill {
    border-radius: ${BORDER_RADIUS};
  }

  /* WebKit styles */
  &::-webkit-progress-bar {
    background-color: ${({ theme }) => theme.designSystem.highlightedBackground};
    border-radius: ${BORDER_RADIUS};
  }

  &::-webkit-progress-value {
    background-color: ${({ theme }) => theme.designSystem.darkerAccent};
    border-radius: ${BORDER_RADIUS};
    border: 1px solid ${({ theme }) => theme.designSystem.highlightedBackground};

    transition: width 200ms ease-in;
  }

  /* Mozilla styles */
  &::-moz-progress-bar {
    background-color: ${({ theme }) => theme.designSystem.darkerAccent};
    border-radius: ${BORDER_RADIUS};
    border: 1px solid ${({ theme }) => theme.designSystem.highlightedBackground};
  }
`;
